<template>
  <div>
    <loading :active.sync="isLoading"></loading>
    <template v-if="isRenderEditForm">
      <add-edit-service-area />
    </template>
    <div class="flex flex-wrap" v-if="service_area != null">
      <div
        :class="
          is_full
            ? 'w-0'
            : 'w-1/2 px-6 py-4 bg-white md-max:w-full md-max:px-4 flex-wrap'
        "
      >
        <div class="flex flex-wrap items-center">
          <div class="flex items-center w-2/3 pl-2 md-max:w-full md-max:pl-2">
            <div
              class="items-center justify-center mr-4 cursor-pointer back-button"
              @click="goBack"
            >
              <i class="fas fa-arrow-left"></i>
            </div>
            <span class="title">{{ titleText }}</span>
            <h3 class="pl-1 font-semibold text-gray-900 text-22px">
              {{
                $t('components.serviceAreaManagement.details.headline.details')
              }}
              (#{{ id | onlyLastFive }})
            </h3>
          </div>
          <div
            class="flex items-center justify-end w-1/3 pl-2 md-max:w-full md-max:pl-0 md-max:pt-6"
          >
            <oto-edit-button @click="edit" />
          </div>
        </div>

        <div
          class="flex flex-col mt-4 mb-10 space-x-0 space-y-4 md:space-x-4 md:space-y-0 md:items-center md:flex-row"
        >
          <SummaryCard
            :title="
              $t(
                'components.serviceAreaManagement.details.summary.totalVehicles'
              )
            "
            :value="service_area.total_vehicles || 0"
            variant="gray"
          />
          <SummaryCard
            :title="
              $t(
                'components.serviceAreaManagement.details.summary.outOfGeofence'
              )
            "
            :value="service_area.vehicles_outside"
            variant="gray"
          />
        </div>

        <div class="flex items-center my-12">
          <div class="block w-1/2 pl-2">
            <span class="block detail-title">{{
              $t('components.serviceAreaManagement.details.serviceAreaName')
            }}</span>
            <span class="block mt-4 detail-value">{{ service_area.name }}</span>
          </div>
          <div class="block w-1/2 pl-4">
            <span class="block detail-title">{{
              $t('components.serviceAreaManagement.details.assignedFleet')
            }}</span>
            <span class="block mt-4 detail-value">{{
              service_area.fleet ? service_area.fleet.name : '--'
            }}</span>
          </div>
        </div>

        <div class="flex items-center my-12">
          <div class="block w-1/2 pl-2">
            <span class="block detail-title">{{
              $t('components.serviceAreaManagement.details.speedLimit')
            }}</span>
            <span class="block mt-4 detail-value">{{
              service_area.speed_limit
                ? service_area.speed_limit.speed_choice
                : '--'
            }}</span>
          </div>
          <div class="block w-1/2 pl-4">
            <span class="block detail-title">{{
              $t('components.serviceAreaManagement.details.vehicleSpeedMode')
            }}</span>
            <span class="block mt-4 detail-value"
              >{{ getSpeedLimit(service_area) }} (kmp/h)</span
            >
          </div>
        </div>

        <div class="flex items-center my-12">
          <div class="block w-1/2 pl-2">
            <span class="block detail-title">{{
              $t('components.serviceAreaManagement.details.type')
            }}</span>
            <span class="block mt-4 detail-value">{{
              service_area.draw_type == 'P' ? 'Polygon' : 'Circle'
            }}</span>
          </div>
          <div class="block w-1/2 pl-4">
            <span class="block detail-title">{{
              $t('components.serviceAreaManagement.details.serviceAreaNote')
            }}</span>
            <span class="block mt-4 detail-value">{{
              service_area.description ? service_area.description : ''
            }}</span>
          </div>
        </div>
        <div class="flex items-center my-12">
          <div class="block w-1/2 pl-2">
            <span class="block detail-title">{{
              $t(
                'components.serviceAreaManagement.details.allowOutsideOfServiceAreaSpeedModeChange'
              )
            }}</span>
            <span class="block mt-4 detail-value">{{
              service_area.reset_speed_mode_for_exiting
                ? $t('components.serviceAreaManagement.details.exitSpeedMode')
                : $t('components.serviceAreaManagement.details.no')
            }}</span>
          </div>
          <div
            class="block w-1/2 pl-4"
            v-if="service_area.reset_speed_mode_for_exiting"
          >
            <span class="block detail-title">{{
              $t('components.serviceAreaManagement.details.exitSpeedMode')
            }}</span>
            <span class="block mt-4 detail-value">{{
              getExitSpeedVariant(service_area.exit_speed_mode)
            }}</span>
          </div>
        </div>
        <input-label
          class="my-2 font-bold "
          :text="
            $t(
              'components.serviceAreaManagement.details.vehicleGoesOutsideOfBoundaryShould'
            )
          "
        />
        <div class="flex items-center md-max:flex-wrap">
          <div class="w-1/2 pl-2 pr-4 md-max:w-full md-max:px-0 md-max:py-3">
            <div
              :class="
                this.service_area.should_throttle == true
                  ? 'toggle-button-active flex items-center justify-center'
                  : 'toggle-button flex items-center justify-center'
              "
            >
              <div class="grid w-3/5">
                <span class="toggle-title">{{
                  $t('components.serviceAreaManagement.details.throttle')
                }}</span>
              </div>
              <div class="w-2/5">
                <div class="flex items-center">
                  <t-toggle
                    variant="success"
                    :checked="this.service_area.should_throttle"
                    readonly
                  />
                  <span class="ml-2 text-sm font-semibold">{{
                    this.service_area.should_throttle
                      ? $t('components.serviceAreaManagement.details.on')
                      : $t('components.serviceAreaManagement.details.off')
                  }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="w-1/2 pl-4 md-max:w-full md-max:pl-0">
            <div
              :class="
                this.service_area.should_trigger == true
                  ? 'toggle-button-active flex items-center justify-center'
                  : 'toggle-button flex items-center justify-center'
              "
            >
              <div class="grid w-3/5">
                <span class="toggle-title">{{
                  $t('components.serviceAreaManagement.details.triggerAlarm')
                }}</span>
              </div>
              <div class="w-2/5">
                <div class="flex items-center">
                  <t-toggle
                    variant="success"
                    :checked="this.service_area.should_trigger"
                    readonly
                  />
                  <span class="ml-2 text-sm font-semibold">{{
                    this.service_area.should_trigger
                      ? $t('components.serviceAreaManagement.details.on')
                      : $t('components.serviceAreaManagement.details.off')
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        :class="is_full ? 'w-full relative' : 'w-1/2 relative md-max:w-full'"
      >
        <gmap-map
          ref="map"
          :zoom="zoom"
          :center="center"
          map-type-id="terrain"
          style="width: 100%; height: 100vh;"
        >
        </gmap-map>
      </div>
    </div>
  </div>
</template>

<script>
import { ServiceAreaConfig } from '@/config/ServiceAreaConfig'
import { gmapApi } from 'vue2-google-maps'
import OtoEditButton from '@/components/ui/OtoEditButton.vue'
import AddEditServiceArea from '@/views/geofence/service-area/AddEditServiceArea'
import { EventBus } from '@/utils/EventBus'
import SummaryCard from '@/components/cards/SummaryCard'
export default {
  name: 'ViewServiceArea',
  components: {
    OtoEditButton,
    AddEditServiceArea,
    SummaryCard,
    InputLabel: () => import('@/components/form/InputLabel'),
  },
  data() {
    return {
      isLoading: false,
      isRenderEditForm: false,
      item: {},
      form: {
        should_trigger: true,
        should_throttle: false,
        coords: null,
      },
      center: {
        lat: 10,
        lng: 10,
      },
      errors: [],
      sorId: ServiceAreaConfig.events.sorId,
      scrollwheel: true,
      zoom: 12,
      zoomControl: true,
      mapTypeControl: false,
      scaleControl: true,
      streetViewControl: false,
      rotateControl: true,
      fullscreenControl: true,
      markers: [{}],
      edited: null,
      map: null,
      drawingManager: null,
      mapDrawingMode: 'Polygonal',
      parsedPolygon: null,
      drawingOptions: {
        fillColor: '#4aff5c40',
        fillOpacity: 1,
        strokeWeight: 4,
        strokeColor: '#00b44d',
        clickable: false,
        draggable: false,
        editable: false, // TODO: make this work with wrapper func
        zIndex: 1,
      },

      service_area: null,

      type: '',
      is_full: false,
      polygons: [],
    }
  },

  computed: {
    google: gmapApi,
    drawingType: function() {
      return [
        {
          id: 'CIRCLE',
          name: 'Circle',
        },
        {
          id: 'POLYGON',
          name: 'Polygon',
        },
      ]
    },
    id() {
      return this.$route.params.id
    },
    titleText: function() {
      return `${this.$t(
        'components.serviceAreaManagement.details.headline.serviceArea'
      )} /`
    },
  },
  async mounted() {
    this.initFunc()
    window.addEventListener(ServiceAreaConfig.events.refresh, () => {
      this.isRenderEditForm = false
      this.initFunc()
    })
  },

  methods: {
    getSpeedLimit(area) {
      if (area.speed_limit) {
        return `${
          area.fleet[
            `${area.speed_limit.speed_choice.toLowerCase()}_speed_limit`
          ]
        }`
      } else {
        return '--'
      }
    },
    edit: async function() {
      this.isRenderEditForm = true
      var serviceAreaDetails = await this.$http
        .get(ServiceAreaConfig.api.details(this.id))
        .then((res) => res.data)
        .catch((err) => console.log(err))
      if (serviceAreaDetails == undefined) return

      delete serviceAreaDetails.created_at
      delete serviceAreaDetails.updated_at
      delete serviceAreaDetails.created_by
      delete serviceAreaDetails.organization

      serviceAreaDetails.existing_fleet = serviceAreaDetails.fleet
      serviceAreaDetails.fleet = serviceAreaDetails.fleet
        ? serviceAreaDetails.fleet.id
        : null
      serviceAreaDetails.speed_limit = serviceAreaDetails.speed_limit.id

      EventBus.$emit(ServiceAreaConfig.events.editingData, serviceAreaDetails)
      dispatchEvent(new Event(ServiceAreaConfig.events.sorToggle))
    },
    getExitSpeedVariant(variant) {
      if (variant === 'L') {
        return 'Low'
      } else if (variant === 'M') {
        return 'Medium'
      } else {
        return 'High'
      }
    },

    goBack() {
      this.$router.push('/geofence/service-areas')
      this.$store.dispatch('fsTable/fetchData')
    },

    async initFunc() {
      this.isLoading = true
      await this.$http
        .get(ServiceAreaConfig.api.details(this.id))
        .then((res) => {
          console.log('res = ', res.data)
          this.service_area = res.data
        })
        .catch((err) => {
          console.log('vehicle-header-err', err)
          this.isLoading = false
        })

      console.log(this.id)
      this.isLoading = false
      this.initDraw()
    },

    initDraw() {
      var self = this
      setTimeout(() => {
        console.log('updated')
        if (!self.$refs.map) return
        self.$refs.map.$mapPromise.then((map) => {
          console.log('Hitting promise with', map)
          self.map = map
          if (self.service_area != null) {
            const overlay = self.parseToOverlay(this.service_area.coords)
            self.setOverlayOnMap(overlay, 'service')
            self.setMapCenterToDrawingCenter(overlay, false)
          }
        })
      }, 1000)
    },

    parseToOverlay(coords) {
      if (!coords) return
      var coordsMorph = coords.replaceAll('{', '')
      coordsMorph = coordsMorph.replaceAll('}', '')
      var coordsArr = coordsMorph.split(',')
      if (!coordsArr.length % 2 === 0) {
        if (coordsArr[coordsArr.length - 1] == ',') {
          console.log('Hit pop')
          coordsArr.pop()
        }
      }
      // console.log("")
      var payload = []
      for (var i = 0; i < coordsArr.length; i = i + 2) {
        // console.log("lat", coordsArr[i])
        // console.log("lon", coordsArr[i+1])
        const lat = parseFloat(coordsArr[i])
        const lng = parseFloat(coordsArr[i + 1])
        if (isNaN(lat) || isNaN(lng)) continue
        payload.push({
          lat: lat,
          lng: lng,
        })
      }
      return payload
    },

    setOverlayOnMap(payload, type) {
      var options = {}
      if (type == 'service') {
        options = this.drawingOptions
      }
      this.parsedPolygon = new this.google.maps.Polygon({
        paths: payload,
        ...options,
      })
      this.parsedPolygon.setMap(this.map)

      this.polygons.push(this.parsedPolygon)

      console.log(payload)
      console.log('SET ON MAP')
    },

    setMapCenterToDrawingCenter(paths, panToCenter = true) {
      var bounds = new this.google.maps.LatLngBounds()
      for (const path of paths) {
        bounds.extend(path)
      }
      const newCenter = bounds.getCenter()
      console.log('NEW CENTER ', newCenter)
      if (panToCenter) {
        this.map.panTo(newCenter)
      } else {
        this.center.lat = newCenter.lat()
        this.center.lng = newCenter.lng()
      }
      this.map.fitBounds(bounds)
    },
  },
}
</script>

<style lang="scss" scoped>
.toggle-button-active {
  border: 1px solid #1bca09;
  width: 100%;
  height: 140px;
  border-radius: 4px;
  padding-left: 20px;
  padding-right: 20px;
}
.toggle-button {
  width: 100%;
  height: 140px;
  border: 1px solid #cbd5e0;
  border-radius: 4px;
  padding-left: 20px;
  padding-right: 20px;
}
.toggle-title {
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #2e2e39;
}
.toggle-description {
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  margin-top: 10px;
  @apply text-gray-600;
}
.detail-title {
  font-family: Roboto;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #2e2e39;
}
.detail-value {
  font-family: Roboto;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #787881;
}
.title {
  font-size: 18px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #9393a2;
}
</style>
